import login from './login'
import nav from './_nav.json'
import activity from './activity'
import dict from './dict.json'
import demo from './demo.json'

export default {
  site_title: 'JDYun.com',
  title: 'JDYun Aktivitätssystem',
  system_demo: 'System-Demo',
  confirm: 'Bestätigen',
  cancel: 'Abbrechen',
  show: 'Anzeigen',
  hide: 'Ausblenden',
  open: 'Öffnen',
  close: 'Schließen',
  save: 'Speichern',
  edit: 'Bearbeiten',
  delete: 'Löschen',
  add: 'Hinzufügen',
  search: 'Suchen',
  query: 'Abfrage',
  reset: 'Zurücksetzen',
  submit: 'Einreichen',
  upload: 'Hochladen',
  download: 'Herunterladen',
  export: 'Exportieren',
  import: 'Importieren',
  started: 'Gestartet',
  ended: 'Beendet',
  next: 'Weiter',
  prev: 'Zurück',
  publish: 'Veröffentlichen',
  input: 'Bitte {text} eingeben',
  select: 'Bitte {text} auswählen',
  total: 'Gesamt {total}',
  price: '{price} EUR',
  required: '{text} ist erforderlich',
  selected: '{total} {text} ausgewählt',
  create: 'Erstellen',
  free: 'Kostenlos',
  charge: 'Kostenpflichtig',
  default: 'Standard',
  custom: 'Benutzerdefiniert',
  max: 'Maximum',
  min: 'Minimum',
  percent: 'Prozent',
  online: 'Online',
  offline: 'Offline',
  name: 'Name',
  remark: 'Anmerkung',
  tips: 'Tipps',
  header: {
    logout: 'Abmelden',
    binding: 'Konto verknüpfen',
    mobile: 'Mobiler Händlerclient',
    register: 'Mobiler Client',
    tips: 'Aktivität {name}',
    qrcodeText: '{name} H5 QR-Code',
    qrcodeMiniText: '{name} Applet-Code',
    qrcode: 'Klicken Sie zum Herunterladen des QR-Codes',
    qrcodeMini: 'Klicken Sie zum Herunterladen des Applet-Codes'
  },
  home: {
    title: 'Willkommen auf der Jindouyun Aktivitätsverwaltungsplattform',
    sub_title: 'Veröffentlichen Sie hier die vollständigsten und detailliertesten Aktivitäten und Konferenzveranstaltungen',
    desc: 'Beginnen Sie Ihre Aktivitätsveranstaltungsreise mit der Aktivitätsverwaltung',
    create: 'Schnell eine Aktivität erstellen'
  },
  user: {
    title: 'Kontobasisinformationen',
    logo: 'Markenlogo',
    update: 'Aktualisieren',
    name: 'Firmen- oder Organisationsname',
    short_name: 'Marke in der oberen linken Menüleiste',
    enable: 'Personalisierte Anmeldung aktivieren',
    web_tips: 'Personalisierte Anmelde-URL',
    copy: 'URL kopieren',
    login: 'Markenname auf der Anmeldeseite',
    login_title: 'Systemname auf der Anmeldeseite'
  },
  login,
  activity,
  demo,
  ...nav,
  ...dict,
  // 状态码本地化
  // 返回操作成功
  // CODE_SUCCESS: 2000,
  2000: 'Vorgang erfolgreich',
  5000: 'Netzwerkanforderung fehlgeschlagen, bitte überprüfen Sie Ihr Netzwerk',
  5001: 'Fehler bei Anfrageparametern',
  5002: 'URL-Registrierung fehlgeschlagen',
  5003: 'Parameterfehler',
  5004: 'Berechtigungsfehler',
  5100: 'JWT-Überprüfung fehlgeschlagen',
  5101: 'Anmeldung fehlgeschlagen',
  5102: 'JWT ungültig',
  5103: 'Benutzer existiert nicht',
  5401: 'Fehler im Parameter "size"',
  5402: 'Fehler im Parameter "page"',
  5403: 'Fehler im Suchschlüsselwort'
} 


// WEBPACK FOOTER //
// ./src/langs/de/index.js